module.exports = __webpack_public_path__ + "static/media/ostersund.91c7f587.jpg";